import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';

/**
 * Wrapper component, detects text overflow and display popover with full text on hover event
 * @param {*} props
 * @param {Boolean} props.multiline - use if children consists of few html elements
 */

const OverflowTooltip = ({ children, className, multiline, byHeight }) => {
  const [tooltipDisabled, setTooltipDisabled] = useState(true);
  const nodeRef = useRef(null);

  const detectOverflow = () => {
    if (byHeight) {
      return multiline
        ? [...nodeRef.current.children[0].children].some((it) => {
          return it.scrollHeight > it.offsetHeight;
        }) || [...nodeRef.current.children].length > 2
        : nodeRef.current.scrollHeight > nodeRef.current.offsetHeight;
    }
    return multiline
      ? [...nodeRef.current.children[0].children].some((it) => {
        return it.scrollWidth > it.offsetWidth;
      }) || [...nodeRef.current.children].length > 2
      : nodeRef.current.scrollWidth > nodeRef.current.offsetWidth;
  };

  const handleMouseOver = () => {
    setTooltipDisabled(!detectOverflow());
  };

  const handleMouseLeave = () => {
    setTooltipDisabled(true);
  };

  return (
    <>
      <div
        className={className}
        aria-haspopup="true"
        onMouseEnter={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        ref={nodeRef}
      >
        <Tooltip channel="desktop" content={children} disableTooltip={tooltipDisabled} interactive>
          {children}
        </Tooltip>
      </div>
    </>
  );
};

OverflowTooltip.propTypes = {
  className: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  byHeight: PropTypes.bool
};

OverflowTooltip.defaultProps = {
  multiline: false,
  byHeight: false
};
export default OverflowTooltip;
